import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4465b420 from 'nuxt_plugin_sentryserver_4465b420' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7813b468 from 'nuxt_plugin_sentryclient_7813b468' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_dayjsplugin_3974059e from 'nuxt_plugin_dayjsplugin_3974059e' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_plugin_3c8781f8 from 'nuxt_plugin_plugin_3c8781f8' // Source: ./nuxt-perfect-cache/plugin.js (mode: 'all')
import nuxt_plugin_tooltippluginb8d776b0_d9ca9448 from 'nuxt_plugin_tooltippluginb8d776b0_d9ca9448' // Source: ./tooltip.plugin.b8d776b0.js (mode: 'all')
import nuxt_plugin_configpluginripple176d10aa_f0dcda42 from 'nuxt_plugin_configpluginripple176d10aa_f0dcda42' // Source: ./config.plugin-ripple.176d10aa.js (mode: 'all')
import nuxt_plugin_pluginserver_80004912 from 'nuxt_plugin_pluginserver_80004912' // Source: ./nuxt-booster/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_5a4669ef from 'nuxt_plugin_pluginclient_5a4669ef' // Source: ./nuxt-booster/plugin.client.js (mode: 'client')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_pluginserver_359dfc90 from 'nuxt_plugin_pluginserver_359dfc90' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_6036e9f0 from 'nuxt_plugin_pluginclient_6036e9f0' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_functions_55e262f2 from 'nuxt_plugin_functions_55e262f2' // Source: ../plugins/functions.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_simplebarclient_fed292ee from 'nuxt_plugin_simplebarclient_fed292ee' // Source: ../plugins/simplebar.client.js (mode: 'client')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../plugins/click-outside.js (mode: 'client')
import nuxt_plugin_multiselect_25a96358 from 'nuxt_plugin_multiselect_25a96358' // Source: ../plugins/multiselect.js (mode: 'all')
import nuxt_plugin_webauthn_7000fa8f from 'nuxt_plugin_webauthn_7000fa8f' // Source: ../plugins/webauthn.js (mode: 'client')
import nuxt_plugin_htmlstatic_514cdbc6 from 'nuxt_plugin_htmlstatic_514cdbc6' // Source: ../plugins/html-static.js (mode: 'all')
import nuxt_plugin_auth_271f3cf8 from 'nuxt_plugin_auth_271f3cf8' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_authredirect_4c7e876c from 'nuxt_plugin_authredirect_4c7e876c' // Source: ../plugins/auth-redirect.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"CVing","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"hid":"description","name":"description","content":"CVing - La prima platform experience dedicata al mondo del lavoro, esperienza, intrattenimento, carriera"},{"name":"format-detection","content":"telephone=no"},{"hid":"robots","name":"robots","content":"noindex,nofollow"},{"info":"develop"},{"http-equiv":"X-Clacks-Overhead","content":"GNU Terry Pratchett"}],"script":[{"hid":"gr-popups-guard","innerHTML":"(function(){\n          if (!\u002F^\\\u002F(?:(?:en|fr|es|pt|de)\\\u002F)?(?:offerte-lavoro|job-offers|offres-emploi|ofertas-empleo|ofertas-emprego|job-angebote)(?:\\\u002F|$)\u002F.test(location.pathname)) { return }\n          var head = document.head\n          var append = head.appendChild\n          head.appendChild = function (node) {\n            if (node && node.tagName === 'SCRIPT' && \u002F\\\u002Fgr-popups\\.js\u002F.test(node.src || '')) { return node }\n            return append.call(this, node)\n          }\n        })();"},{"hid":"getresponse-analytics","type":"text\u002Fjavascript","src":"https:\u002F\u002Fmarketing.cving.com\u002Fscript\u002F9cf9ef2e-bf69-43c5-889f-8d6d163df52d\u002Fga.js","crossorigin":"use-credentials","defer":true,"async":true},{"hid":"nuxt-color-mode-script","innerHTML":"!function(){\"use strict\";var e=window,s=document,t=s.documentElement,n=[\"dark\",\"light\"],o=function(e){for(var t=e+\"=\",n=s.cookie.split(\";\"),o=0;o\u003Cn.length;o++){for(var a=n[o];\" \"===a.charAt(0);)a=a.substring(1,a.length);if(0===a.indexOf(t))return a.substring(t.length,a.length)}return null}(\"nuxt-color-mode\")||\"system\",a=\"system\"===o?c():o;function i(e){var s=\"\"+e+\"\";t.classList?t.classList.add(s):t.className+=\" \"+s}function r(s){return e.matchMedia(\"(prefers-color-scheme\"+s+\")\")}function c(){if(e.matchMedia&&\"not all\"!==r(\"\").media)for(var s of n)if(r(\":\"+s).matches)return s;return\"system\"}i(a),e[\"__NUXT_COLOR_MODE__\"]={preference:o,value:a,getColorScheme:c,addClass:i,removeClass:function(e){var s=\"\"+e+\"\";t.classList?t.classList.remove(s):t.className=t.className.replace(new RegExp(s,\"g\"),\"\")}}}();\n","pbody":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fgtm.cving.com\u002Fjkbaebxb.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NJB4MT2')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"getresponse-analytics":["innerHTML"],"gr-popups-guard":["innerHTML"],"nuxt-color-mode-script":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.gstatic.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fcving.twic.pics","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fcvingdevstaging.twic.pics","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fs3.cving.com","crossorigin":true},{"rel":"preconnect","href":"https:\u002F\u002Fmedia.cving.com","crossorigin":true}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fgtm.cving.com\u002Fns.html?id=GTM-NJB4MT2&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4465b420 === 'function') {
    await nuxt_plugin_sentryserver_4465b420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7813b468 === 'function') {
    await nuxt_plugin_sentryclient_7813b468(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3974059e === 'function') {
    await nuxt_plugin_dayjsplugin_3974059e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3c8781f8 === 'function') {
    await nuxt_plugin_plugin_3c8781f8(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltippluginb8d776b0_d9ca9448 === 'function') {
    await nuxt_plugin_tooltippluginb8d776b0_d9ca9448(app.context, inject)
  }

  if (typeof nuxt_plugin_configpluginripple176d10aa_f0dcda42 === 'function') {
    await nuxt_plugin_configpluginripple176d10aa_f0dcda42(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_80004912 === 'function') {
    await nuxt_plugin_pluginserver_80004912(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_5a4669ef === 'function') {
    await nuxt_plugin_pluginclient_5a4669ef(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_359dfc90 === 'function') {
    await nuxt_plugin_pluginserver_359dfc90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_6036e9f0 === 'function') {
    await nuxt_plugin_pluginclient_6036e9f0(app.context, inject)
  }

  if (typeof nuxt_plugin_functions_55e262f2 === 'function') {
    await nuxt_plugin_functions_55e262f2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_simplebarclient_fed292ee === 'function') {
    await nuxt_plugin_simplebarclient_fed292ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselect_25a96358 === 'function') {
    await nuxt_plugin_multiselect_25a96358(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webauthn_7000fa8f === 'function') {
    await nuxt_plugin_webauthn_7000fa8f(app.context, inject)
  }

  if (typeof nuxt_plugin_htmlstatic_514cdbc6 === 'function') {
    await nuxt_plugin_htmlstatic_514cdbc6(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_271f3cf8 === 'function') {
    await nuxt_plugin_auth_271f3cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_authredirect_4c7e876c === 'function') {
    await nuxt_plugin_authredirect_4c7e876c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
